const indianFormatter = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2,
  });
  
  export const currencyFormat = (value) => {
    if (value === null || value === undefined || Number.isNaN(value)) return "-";
    return indianFormatter.format(value);
  };
  
  const formatWithUnits = (value, suffix = "") =>
    `${currencyFormat(value)}${suffix}`;
  
  export default formatWithUnits;